var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDestinatarios(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_63_8",
    "data-name": "Componente 63 \\u2013 8",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_271",
    "data-name": "Rect\\xE1ngulo 271",
    width: 32,
    height: 32,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "outgoing_mail_FILL0_wght300_GRAD0_opsz40",
    d: "M114.92-810.189h-5.961a.889.889,0,0,1-.657-.266.9.9,0,0,1-.265-.66.883.883,0,0,1,.265-.655.9.9,0,0,1,.657-.261h5.961l-2.206-2.258a.914.914,0,0,1-.255-.636.882.882,0,0,1,.268-.65.866.866,0,0,1,.64-.263.877.877,0,0,1,.644.265l3.646,3.66a1.176,1.176,0,0,1,.26.379,1.092,1.092,0,0,1,.086.424,1.1,1.1,0,0,1-.086.425,1.174,1.174,0,0,1-.26.38l-3.66,3.66a.859.859,0,0,1-.638.262.9.9,0,0,1-.648-.279.836.836,0,0,1-.255-.632.922.922,0,0,1,.258-.635Zm-22.623,0a2.208,2.208,0,0,1-1.617-.678A2.208,2.208,0,0,1,90-812.484V-827.7a2.208,2.208,0,0,1,.678-1.617A2.208,2.208,0,0,1,92.3-830h19.622a2.208,2.208,0,0,1,1.617.678,2.208,2.208,0,0,1,.678,1.617v7.286a.881.881,0,0,1-.282.641.9.9,0,0,1-.65.281.875.875,0,0,1-.651-.265.9.9,0,0,1-.26-.657v-6.327L101.96-819.3l-10.116-7.425v14.238a.44.44,0,0,0,.127.325.44.44,0,0,0,.325.127H103.96a.889.889,0,0,1,.657.266.9.9,0,0,1,.265.66.883.883,0,0,1-.265.655.9.9,0,0,1-.657.261Zm.687-17.966,8.978,6.6,9.226-6.6h-18.2Zm-1.138,16.123v0Z",
    transform: "translate(-88.002 834)",
    fill: "#e7e7e7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestinatarios);
export default __webpack_public_path__ + "static/media/destinatarios.a03ef59f9ec09e004b2e9109f9209798.svg";
export { ForwardRef as ReactComponent };